/**
 * lotesApi — chamadas à API de Lotes (M6) sobre o ApiClient base (todas admin).
 * Respostas no envelope do contrato (`{ data }` / `{ data, nextCursor }`).
 */

import { ApiClient } from './apiClient';
import {
  AprovarLoteResponse,
  CriarLoteInput,
  CriarLoteResponse,
  EstimativaReleitura,
  LoteListItem,
  ReleituraResponse,
} from './lotes-types';

interface Envelope<T> {
  readonly data: T;
}
interface EnvelopeLista<T> {
  readonly data: readonly T[];
  readonly nextCursor: string | null;
}

/** Página de lista já no formato consumido pelos hooks. */
export interface PaginaLotes {
  readonly itens: readonly LoteListItem[];
  readonly nextCursor: string | null;
}

export class LotesApi {
  constructor(private readonly client: ApiClient) {}

  /** GET /lotes — lista paginada com progresso e custo. */
  async listar(cursor?: string, limit = 50): Promise<PaginaLotes> {
    const query = new URLSearchParams();
    query.set('limit', String(limit));
    if (cursor) {
      query.set('cursor', cursor);
    }
    const resp = await this.client.request<EnvelopeLista<LoteListItem>>(`/lotes?${query.toString()}`);
    return { itens: resp.data, nextCursor: resp.nextCursor };
  }

  /** POST /lotes — dispara um lote (piloto, carga total ou incremental). */
  async criar(input: CriarLoteInput): Promise<CriarLoteResponse> {
    const resp = await this.client.request<Envelope<CriarLoteResponse>>('/lotes', {
      method: 'POST',
      body: JSON.stringify(input),
    });
    return resp.data;
  }

  /** GET /lotes/releitura — quantos documentos a releitura dos "outro documento" relê e o custo estimado. */
  async estimarReleitura(): Promise<EstimativaReleitura> {
    const resp = await this.client.request<Envelope<EstimativaReleitura>>('/lotes/releitura');
    return resp.data;
  }

  /** POST /lotes/releitura — dispara a releitura (lote na versão vigente do prompt). */
  async releitura(): Promise<ReleituraResponse> {
    const resp = await this.client.request<Envelope<ReleituraResponse>>('/lotes/releitura', { method: 'POST' });
    return resp.data;
  }

  /** POST /lotes/{id}/aprovacao — aprova a carga total (RN-M6-003). */
  async aprovar(loteId: string): Promise<AprovarLoteResponse> {
    const resp = await this.client.request<Envelope<AprovarLoteResponse>>(
      `/lotes/${encodeURIComponent(loteId)}/aprovacao`,
      { method: 'POST' },
    );
    return resp.data;
  }
}
